<template>
    <div class="page_chpc_lianxi flex-col">
        <div class="group_37 flex-row">
            <div class="group_38 flex-col">
                <div class="list_24 flex-col">
                    <div
                            class="list-items_1 flex-row justify-between"
                            v-for="(item, index) in contactData"
                            :key="index"
                    >
                        <div class="block_10 flex-col">
                            <div class="image-text_41 flex-row">
                                <img class="label_1" referrerpolicy="no-referrer" :src="item.addressIcon" />
                                <span class="text-group_2" v-html="item.lanhutext0"></span>
                            </div>
                            <div class="text-group_59 flex-col">
                                <span class="text_12" v-html="item.lanhutext1"></span>
                                <span class="text_13" v-html="item.lanhutext2"></span>
                            </div>
                            <div class="text-wrapper_96 flex-row">
                                <span class="text_14" v-html="item.lanhutext3"></span>
                                <span class="text_15" v-html="item.lanhutext4"></span>
                                <span class="text_16" v-html="item.lanhutext5"></span>
                            </div>
                            <div v-if="item.slot1 === 1" class="box_30 flex-row">
                                <div class="text-wrapper_5">
                                    <span class="text_17">传真</span>
                                    <span class="text_18">:</span>
                                </div>
                                <span class="text_19">010-58204839</span>
                            </div>
                        </div>
                        <div class="group_image flex-col align-center">
                            <img :src="item.lanhuBg5" alt="Contact Address" class="group_image-img"/>
                        </div>
                    </div>
                </div>
                <div class="block_4 flex-row" >
                    <div class="image-text_42 flex-row justify-between">
                        <img
                                class="label_2"
                                referrerpolicy="no-referrer"
                                src="../../../assets/contact/contact_address.png"
                        />
                        <div class="text-group_60 flex-col">
                            <span class="text_20">各地办事处</span>
                            <span class="text_21">武汉&nbsp;•&nbsp;广州&nbsp;•&nbsp;南京&nbsp;•&nbsp;成都&nbsp;•&nbsp;天津&nbsp;•&nbsp;合肥&nbsp;•&nbsp;无锡&nbsp;•&nbsp;西安</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            contactData: {
                type: Array,
                required: true,
                default: () => []  // 默认空数组
            }
        },
        data() {
            return {
                /*
                contactData: [
                    {
                        lanhuBg0:
                        addressIcon:
                        lanhutext0: '北京总公司',
                        lanhutext1: '北京市朝阳区建国路93号院万达广场8号楼2606室',
                        lanhutext2:
                            'Room&nbsp;2606,Block&nbsp;8,Wanda&nbsp;Plaza,No.93&nbsp;Jianguo&nbsp;Road,&nbsp;Chaoyang&nbsp;District,&nbsp;Beijing&nbsp;100022,P.R.China',
                        lanhutext3: '电话',
                        lanhutext4: ':',
                        lanhutext5: '010-58204887',
                        lanhuBg5: require('../../../assets/contact/contact_address_bj.png'),
                        slot1: 1
                    },
                    {
                        lanhuBg0:
                        addressIcon:
                        lanhutext0: '上海分公司',
                        lanhutext1: '上海市黄浦区中山南一路768号博荟广场C座907室',
                        lanhutext2:
                            'Suite&nbsp;907,Tower&nbsp;C,&nbsp;No.&nbsp;768&nbsp;South&nbsp;1st&nbsp;Zhongshan&nbsp;Road,&nbsp;Huangpu&nbsp;District,&nbsp;Shanghai&nbsp;200023,P.R.China',
                        lanhutext3: '电话',
                        lanhutext4: ':',
                        lanhutext5: '021-63331086',
                        lanhuBg5: require('../../../assets/contact/contact_address_sh.png'),
                    }
                ],
                */
            };
        },
        methods: {}
    };
</script>

<style scoped lang="css"  >
    .page_chpc_lianxi {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .group_37 {

    }
    .flex-row
    {
        display: flex;
        flex-direction: row;
    }

    .group_38 {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        margin-bottom: 59px;
        padding-bottom: 1px;
    }
    flex-col {
        display: flex;
        flex-direction: column;
    }

    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .list_24 {
        max-width: 1200px;
        height: auto;
        margin-top: 30px;
    }
    .flex-col {
        display: flex;
        flex-direction: column;
    }

    .list-items_1 {
        width: 100%;
        max-width: 1200px;
        background-color: #FAFAFA;
        background-size: 100% 100%;
        margin: 0 1px 30px 0;
        padding: 30px 15px 0px 15px;
        align-items: center;

    }
    .list-items_1:hover {
        background: #FFFFFF;
        box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.5);
    }
    .justify-between {
        display: flex;
        justify-content: space-between;
    }

    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .block_10 {

        height: 257px;
        margin-bottom: 2px;
    }

    .image-text_41 {
        width: 152px;
    }

    .label_1 {
        width: 22px;
        height: 30px;
        margin: 2px 0 1px 0;
    }

    .text-group_2 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
        margin-left: 10px;
    }

    .text-group_59 {
        margin-top: 40px;
    }

    .text_12 {
        max-width: 450px;
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 18px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 25px;
    }

    .text_13 {
        max-width: 450px;
        height: 40px;
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        text-align: left;
        line-height: 20px;
        margin-top: 12px;
    }

    .text-wrapper_96 {
        margin: 10px 0 0 0;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;          /* 强制不换行 */
        align-items: center;        /* 垂直居中（可选） */

        width: auto;                /* 或 100%，根据布局调整 */
    }

    .text_14 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
        margin-top: 2px;
    }

    .text_15 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
    }

    .text_16 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
        margin: 2px 0 0 15px;
    }

    .box_30 {
        width: 154px;
        margin: 10px 0 0 0;
    }

    .text-wrapper_5 {
        width: 33px;
        height: 20px;
        overflow-wrap: break-word;
        font-size: 0;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }

    .text_17 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }

    .text_18 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 20px;
    }

    .text_19 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 14px;
        font-family: AlibabaPuHuiTi_3_55_Regular;
        text-align: left;
        white-space: nowrap;
        line-height: 17px;
        margin: 2px 0 0 15px;
    }

    .group_image {
        width: 180px;
        aspect-ratio: 180 / 128;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        margin-right: 50px;
    }

    .group_image-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
    }
    .align-center {
        align-self: center;
    }

    .block_4 {
        max-width: 1200px;
        width: 100%;
        background: #FAFAFA;
        padding: 43px 44px 33px 15px;
        display: flex;
        align-items: center;
        margin: 10px auto 0;
    }
    .block_4:hover {
        background: #FFFFFF;
        box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2);
    }

    .image-text_42 {

    }

    .label_2 {
        width: 22px;
        height: 30px;
        margin: 3px 0 39px 0;
    }

    .text-group_60 {
    }

    .text_20 {
        overflow-wrap: break-word;
        color: rgba(36, 39, 40, 1);
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        line-height: 33px;
        margin-left: 10px;
    }

    .text_21 {
        overflow-wrap: break-word;
        color: rgba(102, 102, 102, 1);
        font-size: 20px;
        text-align: left;
        white-space: nowrap;
        line-height: 28px;
        margin-top: 11px;
    }


    @media (max-width: 678px) {
        .group_38 {
            margin-bottom: 30px;
        }

        .list_24 {
            width: 95%;
            margin-top: 15px;
        }
        .block_4 {
            width: 95%;
            padding: 43px 44px 33px 15px;
        }


        .list-items_1 {
            -webkit-box-orient: vertical;
            -webkit-box-direction: normal;
            -ms-flex-direction: column;
            flex-direction: column;
            margin-bottom: 20px;
        }

        .block_10 {
            width: 100%;
            height: auto;
        }


        .label_1,
        .label_2 {
            width: 18px;
            height: 24px;
        }

        .text-group_2 {
            font-size: 20px;
            line-height: 28px;
        }

        .text-group_59 {
            margin-top: 20px;
        }

        .text_12 {
            font-size: 14px;
            line-height: 22px;
            white-space: normal;
        }

        .text_13 {
            font-size: 12px;
            line-height: 18px;
        }

        .text_14,
        .text_15,
        .text_16,
        .text_17,
        .text_18,
        .text_19 {
            font-size: 12px;
            line-height: 16px;
        }

        .text_19 {
            margin: 0px 0 0 10px;
        }

        .list-items_1 {
            width: 97%;
        }
        /**小屏图片不显示**/
        .group_image {
            display: none;
            width: 0%;
            height: auto;
            margin: 20px 0 0 0;
            aspect-ratio: 16/9;
        }

        .image-text_42 {
            max-width: 450px;
        }

        .label_2 {
            margin: 0 0 15px 0;
        }

        .text_20 {
            font-size: 20px;
            line-height: 23px;
            margin-right: 0;
            margin-left: 10px;
            white-space: normal;
        }

        .text_21 {
            font-size: 12px;
            line-height: 22px;
            margin-left: 10px;
            white-space: normal;
        }
    }

    /* Browser-specific fixes */
    @supports (-webkit-touch-callout: none) {
        /* Safari specific styles */
        .group_image {
            height: 128px;
        }
    }

    @-moz-document url-prefix() {
        /* Firefox specific styles */
        .group_image {
            height: 128px;
        }
    }

</style>
